import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

const Counter = ({ end, prefix = "", suffix = "", decimals = 0, duration = 2.2 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, end, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, end, duration]);

  const formatted = decimals
    ? val.toFixed(decimals)
    : Math.round(val).toLocaleString("en-GB");

  return (
    <span ref={ref}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
};

export default Counter;
